import src from "IMAGE";
export default { src, width: 1094, height: 760, blurWidth: 0, blurHeight: 0};
